import T from '../../services/language';
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router";
import {Container, ContainerView, ContainerViewFooter} from "../../components/Container";
import {Header} from "../../components/Header";
import {NextButton} from "../../components/Button";
import {
    AddOnControl,
    Desc,
    ImageView,
    Quantity,
    QuantityAction,
    QuantityActions,
    QuantityTitle,
    QuantityValue,
    Title
} from "./style";
import {CacheScheduleService, getProductAndService} from "../../services/app";
import {SkeletonViewText} from "../../components/Skeleton";
import {useApp} from "../../contexts/app";
import CarouselImages from "../../components/Carousel";
import {message} from "antd";
import AnonymousChatPopup from "../AnonymoysChat/popup";

export default function ProductServiceDetail(props: any) {
    const {setLocalProductService, clientCode, getLocalAddon, setLocalAddon, removeCurrentBookings} = useApp();
    const [row, setRow] = useState(null);
    const navigate = useNavigate();
    const {
        campaignPath,
        campaignId,
        customerId,
        productServiceId,
        productServiceType,
        productServiceTemplateId
    } = useParams();
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(true);
    const [addOn, setAddOn] = useState([]);

    useEffect(() => {
        loadData();
    }, []);

    const onNext = () => {
        // check max quantity=10
        if (quantity > 10) {
            message.error(T('Max quantity is 10'));
            return;
        }
        setLocalProductService(productServiceId, row);
        CacheScheduleService.clear();
        removeCurrentBookings();
        if (row?.locationType === 'online' || row?.locationType === 'my-location') {
            navigate(`/${clientCode}/${campaignPath}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${row?.pssId}/${quantity}/booking/${row?.locationType}/0`);
        } else {
            navigate(`/${clientCode}/${campaignPath}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${row?.pssId}/${quantity}/postal-code/${row?.locationType}/0`);
        }
    }

    const loadData = async () => {
        setLoading(true);
        const result = await getProductAndService(campaignId, productServiceId);
        if (result.status === 200) {
            setRow(result?.data?.data || {})
        }
        if (getLocalAddon(customerId)) {
            setAddOn(getLocalAddon(customerId))
        }
        setLoading(false);
    }

    const images = [(row?.thumbnailUrl || ""), ...(row?.imageUrls || [])].filter(x => x);
    const showQty = ((!!row?.campaignPssGroup?.orderLimit && row?.campaignPssGroup?.orderLimit > 1) && !loading);
    return (
        <Container>
            <Header title={T("Detail")} back/>

            <ContainerView style={{paddingBottom: 150}}>
                <Title>{loading ? (<SkeletonViewText itemStyle={{width: "70%", height: 24, marginLeft: 0}}
                                                     lines={[1]}/>) : (row?.name)}</Title>
                <ImageView>
                    <CarouselImages height={300}
                                    imageUrls={images?.length ? images : ["/assets/images/default_service.png"]}/>
                </ImageView>

                {!loading && row?.addOn?.length ?
                    <AddOnControl value={addOn || []} onChange={(event) => {
                        setAddOn(event);
                        setLocalAddon(customerId, event);
                    }} options={row?.addOn || []}
                                  mode={row?.isMultipleSelectAddOn ? "multi" : "single"}/> : null}

                <Desc>{loading ? (<SkeletonViewText lines={[1, 2, 3, 4, 5]} itemStyle={{
                    height: 13,
                    marginLeft: 0
                }}/>) : (
                    <div dangerouslySetInnerHTML={{__html: (row?.descriptions || "")}}/>
                )}</Desc>

                <ContainerViewFooter
                    style={showQty ? {boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.01), 0px 0px 10px rgba(0, 0, 0, 0.1)"} : {}}>
                    {
                        showQty ? (
                            <Quantity>
                                <QuantityTitle>{T('Quantity')}</QuantityTitle>
                                <QuantityActions>
                                    <QuantityAction
                                        onClick={() => (quantity > 1 ? setQuantity(quantity - 1) : undefined)}>-</QuantityAction>
                                    <QuantityValue>{quantity}</QuantityValue>
                                    <QuantityAction
                                        className={row?.campaignPssGroup?.orderLimit < quantity ? 'disabled' : ''}
                                        onClick={() => {
                                            if (row?.campaignPssGroup?.orderLimit > quantity) {
                                                setQuantity(quantity + 1)
                                            }
                                        }}>+</QuantityAction>
                                </QuantityActions>
                            </Quantity>
                        ) : null
                    }


                    <NextButton disabled={loading} onClick={() => {
                        onNext()
                    }}>{T('Select')}</NextButton>
                </ContainerViewFooter>

            </ContainerView>
            <AnonymousChatPopup style={showQty ? {bottom: 140} : {}}/>
        </Container>
    )
}
